import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {serialize} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Badge} from 'shared/models/badges/badge';
import {IBadgesDetailsRepository} from './badges-details.repository.interface';

@Injectable()
export class BadgesDetailsHttpRepository implements IBadgesDetailsRepository {

  constructor(private http: Http) { }

  public getBadge(id: string): Observable<Badge> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.badges}/${id}`, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public saveBadge(badge: Badge): Observable<Badge> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(badge);

    return this.http.post(environment.badges, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public updateBadge(badge: Badge): Observable<Badge> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(badge);

    return this.http.put(`${environment.badges}/${badge._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/repositories/badges-details.repository.http.ts